import axios from "axios";

const ACCOUNT_BLOCKED_MESSAGES = [
  "is archived",
  "Account is deactivated",
  "Account Account is pending approval",
  "Account is pending approval",
];

const getServerMessage = (error) => {
  const data = error?.response?.data;

  if (typeof data === "string") {
    return data;
  }

  if (Array.isArray(data?.errors)) {
    return data.errors.filter(Boolean).join(", ");
  }

  if (data?.errors && typeof data.errors === "object") {
    return Object.values(data.errors).flat().filter(Boolean).join(", ");
  }

  return data?.message || data?.error || data?.detail || "";
};

const showBackendErrorSnackbar = (error) => {
  const status = error?.response?.status;

  if (status !== 400 && status !== 403) {
    return;
  }

  const message = getServerMessage(error);

  if (!message || typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent("backend-error-snackbar", {
      detail: { message },
    })
  );
};

const shouldLogoutBlockedAccount = (error) => {
  if (error?.response?.status !== 403) {
    return false;
  }

  const data = error?.response?.data;
  const message = getServerMessage(error);

  if (data?.is_archived || data?.isArchived) {
    return true;
  }

  return ACCOUNT_BLOCKED_MESSAGES.some((blockedMessage) =>
    message.includes(blockedMessage),
  );
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (shouldLogoutBlockedAccount(error)) {
      const message = getServerMessage(error);

      localStorage.clear();
      sessionStorage.setItem("authErrorMessage", message);

      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    } else {
      showBackendErrorSnackbar(error);
    }

    return Promise.reject(error);
  },
);
